import { render, staticRenderFns } from "./tab-section.vue?vue&type=template&id=7c17b46f&scoped=true&"
import script from "./tab-section.vue?vue&type=script&lang=js&"
export * from "./tab-section.vue?vue&type=script&lang=js&"
import style0 from "./tab-section.vue?vue&type=style&index=0&id=7c17b46f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c17b46f",
  null
  
)

export default component.exports